export default () => {
	return {
		root: {
			display: "flex",
			flexDirection: "column",
			overflow: "hidden",
			height: "100%",
		},
		emailsContainer: {
			flexGrow: 1,
			overflow: "auto",
			padding: 8,
		},
		progressContainer: {
			display: "flex",
			justifyContent: "center",
			alignItems: "center",
			height: "100%",
			width: "100%",
		},
		emailItem: {
			margin: 8,
			display: "flex",
			flexDirection: "column",
			"&:not(:last-of-type)": {
				borderBottom: "1px solid #ccc",
			},
		},
		body: {
			overflow: "auto",
			marginTop: 12,
			marginBottom: 0,
		},
		inputContainer: {
			borderBottom: "1px solid #ccc",
			position: "relative",
			display: "flex",
			flexDirection: "column",
			padding: 8,
		},
		richText: {
			display: "flex",
			flexDirection: "column",
			flexGrow: 1,
			maxHeight: "100%",
			"& > .ql-container": {
				overflow: "auto",
			},
		},
		bodyInput: {
			marginTop: 8,
			marginBottom: 0,
		},
		sendButton: {
			marginTop: 8,
			width: 48,
			alignSelf: "flex-end",
		},
		sendProgress: {
			position: "absolute",
			bottom: 0,
			left: 0,
			width: "100%",
		},
		accordionSummary: {
			marginLeft: "0%",
			textAlign: "center",
			background: "#eeeeee",
			padding: 0,
		},
		accordionSummaryRoot: {
			"&.Mui-expanded": {
				maxHeight: 48,
				minHeight: 48,
			},
		},
		accordionSummaryContent: {
			maxWidth: "calc(100% - 60px)",
			"&.Mui-expanded": {
				margin: 0,
			},
		},
		summaryItem: {
			display: "flex",
			width: "100%",
		},
		directionIcon: {
			fontSize: 18,
			marginRight: 8,
		},
		itemSubject: {
			fontWeight: "bold",
			textAlign: "left",
			whiteSpace: "nowrap",
			minWidth: "20%",
			maxWidth: "20%",
			overflow: "hidden",
			textOverflow: "ellipsis",
		},
		itemPreview: {
			overflow: "hidden",
			wordBreak: "break-all",
			textOverflow: "ellipsis",
			whiteSpace: "nowrap",
			flexGrow: 1,
			margin: "0px 8px",
			textAlign: "left",
		},
		itemDate: {
			whiteSpace: "nowrap",
		},
		itemHasAttachment: {
			display: "flex",
			alignItems: "center",
			margin: "0px 8px",
			fontSize: 14,
		},
		email: {
			marginBottom: 8,
		},
		inbound: {
			overflow: "hidden",
			"&::after": {
				content: "''",
				position: "absolute",
				left: 0,
				top: 0,
				height: "100%",
				width: 2,
				backgroundColor: "#cc1f20",
			},
		},
		attachmentsContainer: {
			maxHeight: 112,
			overflow: "auto",
			marginBottom: 8,
		},
		attachmentItem: {
			margin: 2,
			backgroundColor: "rgba(0, 0, 0, 0.1)",
			padding: "4px 4px 4px 8px",
			borderRadius: 4,
			display: "flex",
			alignItems: "center",

			"& > span": {
				flexGrow: 1,
				overflow: "hidden",
				textOverflow: "ellipsis",
				whiteSpace: "nowrap",
				cursor: "default",
				maxWidth: "calc(100% - 28px)",
			},
			"& button": {
				padding: 2,
			},
		},
		sizeLimitWarning: {
			fontSize: 14,
			padding: 4,
			marginBottom: 4,
			color: "#cc1f20",
			display: "flex",
			alignItems: "center",

			"& > svg": {
				fontSize: 20,
				marginRight: 4,
			},
		},
	};
};
